import { Image, type ImageProps } from 'tamagui'

export default function CobuImage(props: ImageProps) {
  return <Image resizeMode="cover" {...props} />
}
